// Zyltrix Beauty — Global JS

// Header scroll effect
const header = document.querySelector('.site-header');
if (header) {
  window.addEventListener('scroll', () => {
    header.classList.toggle('scrolled', window.scrollY > 20);
  }, { passive: true });
}

// Accordion / Collapsible
document.querySelectorAll('.accordion__trigger').forEach(trigger => {
  trigger.addEventListener('click', () => {
    const item = trigger.closest('.accordion__item');
    const isOpen = item.classList.contains('open');
    document.querySelectorAll('.accordion__item.open').forEach(el => el.classList.remove('open'));
    if (!isOpen) item.classList.add('open');
  });
});

// Product gallery thumbnails
document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
  thumb.addEventListener('click', () => {
    const main = document.querySelector('.product-gallery__main img');
    if (main) {
      main.src = thumb.querySelector('img').src;
      main.srcset = thumb.querySelector('img').srcset || '';
    }
    document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  });
});

// Quantity selector + variant pills — wrapped in DOMContentLoaded to ensure DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.qty-btn:not([onclick])').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = btn.closest('.qty-selector').querySelector('.qty-input');
      var val = parseInt(input.value) || 1;
      if (btn.dataset.action === 'minus') val = Math.max(1, val - 1);
      if (btn.dataset.action === 'plus') val = val + 1;
      input.value = val;
    });
  });

  document.querySelectorAll('.variant-pill').forEach(function(pill) {
    pill.addEventListener('click', function() {
      var group = pill.closest('.variant-pills');
      group.querySelectorAll('.variant-pill').forEach(function(p) { p.classList.remove('active'); });
      pill.classList.add('active');
    });
  });
});

// Scroll reveal animation
const observerOptions = { threshold: 0.12, rootMargin: '0px 0px -40px 0px' };
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('animate-in');
      observer.unobserve(entry.target);
    }
  });
}, observerOptions);

document.querySelectorAll('[data-animate]').forEach(el => observer.observe(el));

// Mobile menu handled by header.liquid section script

// Cart count update (Shopify AJAX)
function updateCartCount() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const count = document.querySelector('.cart-count');
      if (count) {
        count.textContent = cart.item_count;
        count.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    })
    .catch(() => {});
}

updateCartCount();
